import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import {CartService} from '../../services/cart.service';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import {AirManagementService}  from 'src/app/services/air-management.service'
import { DatePipe, Location } from '@angular/common';
import {AirConfigService}  from 'src/app/services/air-config.service'
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { UserService } from 'src/app/services/user.service';
import {SettingsService} from '../../services/settings.service';
import { FlightService } from 'src/app/services/flight.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
@Component({
  selector: 'app-generate-pnr',
  templateUrl: './generate-pnr.component.html',
  styleUrls: ['./generate-pnr.component.css'],
  
})
export class GeneratePnrComponent {

retriveData:any=[]

bookingType:any='C'

searchRequest:any
  messageData:any
  userUuid:any
  domIn:any={
    international:false,
    domestic:false
  }



  userName:any={
    userUid:'',
    name:'',
    email:''
  }
  userType:any
flightData:any=[]
constructor(private SettingsService:SettingsService,private data:DataService,private CartService:CartService, private  toastMsgService : ToastmsgService,private userInfoService:UserInfoService,
  private AirManagementService:AirManagementService,private FlightService:FlightService,private AirConfigService:AirConfigService,private userService : UserService,private DialogService:DialogService){
    this.AirConfigService
    this.userType=this.userInfoService.getUserType()
    this.userType=this.userType.toUpperCase()
    this.userUuid=this.userInfoService.getUserUuid()
    this.getUsersList()
    this.AirConfigService
    .getGeneralConfig(this.userUuid)
    .subscribe({
      next : (res:any) => {
        if(res) {
          let data=res
         
         this.domIn.international=data[0]?.internationalEnabled
         this.domIn.domestic=data[0]?.domesticEnabled

    

        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  this.sourceCodelist()
  this.Supplierlist()
  this.Carrierlist()
  this.getFlightList()

    let searchData:any
  this.data.portMessage.subscribe((message:any) =>searchData = message)


   this.userName.email=searchData?.username?.username
   this.userName.name=searchData?.username?.name
   if(this.userType==='CORPORATE'||this.userType==='AGENT'){
    this.userName.userUid=null
  }else {
    this.userName.userUid=searchData?.username?.userUid
  }

     if ('airSearchRequestBaseDetails' in searchData) {
  
  this.searchRequest=searchData
  this.messageData=searchData
  console.log( this.messageData)

  this.searchRequest?.airSearchRequestBaseDetails.forEach((flightItem:any)=>{
    let passengerArray:any=[]
   
    this.travellerArray(this.searchRequest.adultCount).forEach((item:any)=>{
      let passengerDetails={
        passengerType:'ADT',
        bookingClass: '',
        cabinClass: flightItem?.requestedClass,
        fareType:'',
        baseFare: 0,
     YQ: 0,
     YR: 0,
     IN: 0,
     WO: 0,
     JN: 0,
     OB: 0,
     OC: 0,
     SBC: 0,
     KKC: 0,
     CGST: 0,
     SGST: 0,
     UGST: 0,
     IGST: 0,
     seatBasePrice: 0,
     mealBasePrice: 0,
     baggage: 0,
     coc: [ { key: '', value: 0},
     { key: '', value: 0 },
     { key: '', value: 0 }],
     pnr:  '',
  csrPnr: '',
  ticketNumber :'',
  mealPreference:  '',
  seatPreference:'',
  seatNumber: '',
  baggagePreference:''
      }
passengerArray.push(passengerDetails)
    })
    this.travellerArray(this.searchRequest.childCount).forEach((item:any)=>{
      let passengerDetails={
        passengerType: 'CHD',
        bookingClass: '',
        cabinClass: flightItem?.requestedClass,
        fareType:'',
        baseFare: 0,
        YQ: 0,
        YR: 0,
        IN: 0,
        WO: 0,
        JN: 0,
        OB: 0,
        OC: 0,
        SBC: 0,
        KKC: 0,
        CGST: 0,
        SGST: 0,
        UGST: 0,
        IGST: 0,
        seatBasePrice: 0,
        mealBasePrice: 0,
        baggage: 0,
        coc:[ { key: '', value: 0},
        { key: '', value: 0 },
        { key: '', value: 0 }],
        pnr:  '',
  csrPnr: '',
  ticketNumber :'',
  mealPreference:  '',
  seatPreference:'',
  seatNumber: '',
  baggagePreference:''
      }
passengerArray.push(passengerDetails)

    })
    this.travellerArray(this.searchRequest.infantCount).forEach((item:any)=>{

      let passengerDetails={
        passengerType: 'INF',
        bookingClass: 'Unset',
        cabinClass: flightItem.requestedClass,
        fareType:'',
        baseFare: 0,
        YQ: 0,
        YR: 0,
        IN: 0,
        WO: 0,
        JN: 0,
        OB: 0,
        OC: 0,
        SBC: 0,
        KKC: 0,
        CGST: 0,
        SGST: 0,
        UGST: 0,
        IGST: 0,
        seatBasePrice: 0,
        mealBasePrice: 0,
        baggage: 0,
        coc: [ { key: '', value: 0},
        { key: '', value: 0 },
        { key: '', value: 0 }],
        pnr:  '',
  csrPnr: '',
  ticketNumber :'',
  mealPreference:  '',
  seatPreference:'',
  seatNumber: '',
  baggagePreference:''
      }
passengerArray.push(passengerDetails)
    })
let flightData:any= {
  fromAirport:  flightItem?.fromAirport,
  toAirport: flightItem?.toAirport,
  source:  '',
  carrier: this.messageData?.prefAirline,
  supplier:'',
  schDepartureTime: this.datetimeFormate(flightItem?.requestedDate),
  schArrivalTime:  this.datetimeFormate(flightItem?.requestedDate),
  platingCarrier: '',
  flightNumber: '',
  roe: '',
  privateFareCode: '',
  currency: 'INR',
  passengerDetails: passengerArray,
  
}

this.flightData.push(flightData)


  })
 
  for(let i=0;i<this.flightData.length;i++){
    this.flightData[i].pnrItineraryDetails=[this.flightData[i]]

  }
    // console.log(this.flightData)

  }else{
    



 

  this.retriveData=searchData
  this.flightData=this.retriveData[0].pnrItineraryDetails.map((data:any) => {
   
    data.source=data.name
    data.supplier=data.supplierCode
     return { pnrItineraryDetails: data.flights.flightDetailsList.map((pnrItineraryDetailss:any,i:number) => {
      
    const itinerary = pnrItineraryDetailss;
    // console.log(itinerary)
   

    // let passenger:any = [{...data.passengerDetails}].map((ps:any) => Object.values(ps)).flat();

    // console.log(data.passengerDetails)
    // console.log({...data.passengerDetails})
    // console.log([{...data.passengerDetails}])
// console.log(passenger)


let passenger:any =this.retriveData[0].passengerDetails.map((P:any,i:number)=>{
  const ticketNumber =
  P?.flightDetailsWithPassengerPreferences?.find(
    (PassengerPreferences: any) =>
      PassengerPreferences?.fromAirport === pnrItineraryDetailss?.fromAirport &&
      PassengerPreferences?.toAirport === pnrItineraryDetailss?.toAirport &&
      PassengerPreferences?.flightNumber === pnrItineraryDetailss?.flightNumber
  )?.ticketNumber ?? '';
  // console.log(itinerary.bookingClasses.filter((pType:any)=>pType.fareDetailsPerPassengerType.passengerType===P.passengerType))
  const fareDetails = itinerary.bookingClasses.filter((pType:any)=>pType.fareDetailsPerPassengerType.passengerType===P.passengerType)[0].fareDetailsPerPassengerType;
  const taxes = fareDetails?.taxes||{};
  const knownTaxes = {
    YQ: taxes.YQ ? taxes.YQ[0] : 0,
    YR: taxes.YR ? taxes.YR[0] : 0,
    IN: taxes.IN ? taxes.IN[0] : 0,
    WO: taxes.WO ? taxes.WO[0] : 0,
    JN: taxes.JN ? taxes.JN[0] : 0,
    OB: taxes.OB ? taxes.OB[0] : 0,
    OC: taxes.OC ? taxes.OC[0] : 0,
    SBC: taxes.SBC ? taxes.SBC[0] : 0,
    KKC: taxes.KKC ? taxes.KKC[0] : 0,
    CGST: taxes.CGST ? taxes.CGST[0] : 0,
    SGST: taxes.SGST ? taxes.SGST[0] : 0,
    UGST: taxes.UGST ? taxes.UGST[0] : 0,
    IGST: taxes.IGST ? taxes.IGST[0] : 0
  };
  const coc = Object.keys(taxes).filter(key => !Object.keys(knownTaxes).includes(key)).map(key => ({
    key: key,
    value: this.addTotal(taxes[key])
  }));
     return {
  passengerType: fareDetails?.passengerType,
  passengerKey:P?.passengerKey,
  firstName:P?.firstName,
  lastName:P?.lastName,
  passengerTitle:P?.passengerTitle,
email:P?.email,
mobile:P?.mobile,
  bookingClass: itinerary.bookingClasses.filter((pType:any)=>pType.fareDetailsPerPassengerType.passengerType===P.passengerType)[0].bookingClass,
  cabinClass: "Y",
  fareBasis:itinerary.bookingClasses.filter((pType:any)=>pType.fareDetailsPerPassengerType.passengerType===P.passengerType)[0]?.fareBasis,
  baggageInfo:itinerary.bookingClasses.filter((pType:any)=>pType.fareDetailsPerPassengerType.passengerType===P.passengerType)[0]?.baggageInfo,
  fareType: itinerary.bookingClasses.filter((pType:any)=>pType.fareDetailsPerPassengerType.passengerType===P.passengerType)[0]?.fareType, 
  baseFare: fareDetails.baseFare.toString(),
  YQ: this.addTotal(taxes.YQ) ,
  YR: this.addTotal(taxes.YR),
  IN: this.addTotal(taxes.IN),
  WO: this.addTotal(taxes.WO),
  JN: this.addTotal(taxes.JN),
  OB: this.addTotal(taxes.OB),
  OC: this.addTotal(taxes.OC),
  SBC: this.addTotal(taxes.SBC),
  KKC: this.addTotal(taxes.KKC),
  CGST: this.addTotal(taxes.CGST),
  SGST: this.addTotal(taxes.SGST),
  UGST: this.addTotal(taxes.UGST),
  IGST: this.addTotal(taxes.IGST),
  seatBasePrice: 0,
  mealBasePrice: 0,
  baggage: 0,
  coc:coc,
  pnr: this.retriveData[0]?.pnrNumber,
  csrPnr:this.retriveData[0]?.crsPNR,
  ticketNumber:ticketNumber,
  
  universalPnr:this.retriveData[0]?.universalPnr,
  providerPnr:this.retriveData[0]?.providerPnrNumber,
  mealPreference: "",
  seatPreference: "",
  seatNumber: "",
  baggagePreference: ""



}
})

// console.log(itinerary.flightNumber)
    return {
      fromAirport: itinerary?.fromAirport,
      toAirport: itinerary?.toAirport,
      fromTerminal:itinerary?.fromTerminal,
      toTerminal:itinerary?.toTerminal,
      supplier: this.retriveData?.supplier,
      source: this.retriveData?.source,
      carrier: itinerary.carrierName,
      schDepartureTime: itinerary.schDepartureTime.split("+")[0],
      schArrivalTime: itinerary.schArrivalTime.split("+")[0],
      platingCarrier: itinerary.carrierName,
      flightNumber: itinerary.flightNumber,
      roe: "",
      privateFareCode: "",
      currency: "INR",
       passengerDetails:passenger
       //[
      //   {
      //     passengerType: passenger.passengerType,
      //     firstName:passenger.firstName,
      //     lastName:passenger.lastName,
      //     passengerTitle:passenger.passengerTitle,

      //     bookingClass: itinerary.bookingClasses[0].bookingClass,
      //     cabinClass: "",
      //     fareType: itinerary.bookingClasses[0].fareType,
      //     baseFare: fareDetails.baseFare.toString(),
      //     YQ: taxes.YQ ? taxes.YQ[0] : 0,
      //     YR: taxes.YR ? taxes.YR[0] : 0,
      //     IN: taxes.IN ? taxes.IN[0] : 0,
      //     WO: taxes.WO ? taxes.WO[0] : 0,
      //     JN: taxes.JN ? taxes.JN[0] : 0,
      //     OB: taxes.OB ? taxes.OB[0] : 0,
      //     OC: taxes.OC ? taxes.OC[0] : 0,
      //     SBC: taxes.SBC ? taxes.SBC[0] : 0,
      //     KKC: taxes.KKC ? taxes.KKC[0] : 0,
      //     CGST: taxes.CGST ? taxes.CGST[0] : 0,
      //     SGST: taxes.SGST ? taxes.SGST[0] : 0,
      //     UGST: taxes.UGST ? taxes.UGST[0] : 0,
      //     IGST: taxes.IGST ? taxes.IGST[0] : 0,
      //     seatBasePrice: 0,
      //     mealBasePrice: 0,
      //     baggage: 0,
      //     coc:coc,
      //     pnr: data.pnrNumber,
      //     csrPnr: data.crsPNR,
      //     ticketNumber: passenger.ticketNumber,
      //     mealPreference: "",
      //     seatPreference: "",
      //     seatNumber: "",
      //     baggagePreference: ""
      //   }
      // ]
    }}),
    
    
  }
});


this.flightData.forEach((item:any)=>{
  console.log(item)
  item.pnrItineraryDetails.forEach((travellers:any)=>{

    travellers.passengerDetails.forEach((traveller:any)=>{
    this.total(traveller)
    
  }
  )})
})

}
}



 // Data for the form
//  reseller: string = '';
//  personalSelfPay: boolean = false;
//  defaultPfCode: string = '';

addTotal(data:any){
  if(data&&data.length>0){
    let total:any=0
    for(let item of data ){

total+=Number(item)
console.log(total)

    }
    return total

  }
  return 0

}
 // Function to create a cart
 createCart() {
// console.log(this.flightData)
let cabin:any=[{requestedClass:this.flightData[0]?.pnrItineraryDetails[0]?.passengerDetails[0]?.cabinClass}]
  let request={
      // "orderId": "ORD123456",
      // "pnr": "PNR987654",
      // "paymentMedium": "CREDIT_CARD",
      "requestUuid": this.searchRequest?.requestId,
      "channel": "WEB",
      // "airSearchRequest": this.searchRequest,

      "airSearchRequest": {
        "domestic": this.domIn.domestic,
        "paxCount": this.searchRequest?.paxCount,
        "requestId": this.searchRequest?.requestId,
        "adultCount": this.searchRequest?.adultCount,
        "childCount": this.searchRequest?.childCount,
        "travelType": this.searchRequest?.travelType,
        "infantCount": this.searchRequest?.infantCount,
        "journeyType": this.searchRequest?.journeyType,
        "prefAirline": this.searchRequest?.prefAirline,
        "directFlight": this.searchRequest?.directFlight||false,
        "international": this.domIn?.international,
        "airSearchRequestBaseDetails":this.searchRequest?.airSearchRequestBaseDetails||cabin,
        // "userBookingContext":this.bookingType
 
      },

      "flightBooking":this.convertData(this.flightData),
      "travellerDetails": {
        "adult": this.searchRequest?.adultCount ||    this.retriveData[0]?.passengerDetails?.filter((passenger:any) => passenger.passengerType === 'ADT').length ||0,
        "child": this.searchRequest?.childCount||    this.retriveData[0]?.passengerDetails?.filter((passenger:any) => passenger.passengerType === 'CHD').length||0,
        "infantCount": this.searchRequest?.infantCount ||    this.retriveData[0]?.passengerDetails?.filter((passenger:any) => passenger.passengerType === 'INF').length||0
      },
      "bookedFor": "Business",
      "userUid": this.userName.userUid
    }
    

  
  


   this.CartService
   .saveCart(request)
   .subscribe({
     next : (res:any) => {
       if(res) {
        let item:any
        item=res  
         sessionStorage.setItem('CorpUuid',this.userName.userUid)

      //  let url= "/app/manual-booking?id="+this.SettingsService.transform(item?.orderNumber)
      //  window.open(url);

         this.toastMsgService.setMsg({msg : 'Cart Added Successfully',msgTitle : "Success", msgType : "I"});

        

         this.myOutput.emit(this.outputMessage);

         this.DialogService.open({msg : 'Redirect to the Cart ('+item?.orderNumber+')',title : "Confirmation",buttonType : "YesNo"})
       
         this.DialogService.onResponse((response :  string) => {
          
           if(response=="Yes") {
            let url="/app/modify-cart?id="+item?.orderNumber
            window.open(url) 
 
           }})
       } else {
       
       } 
     },error : (err) => {
       this.toastMsgService.setMsg({msg : 'Failed to Save Cart',msgTitle : "Warning", msgType : "W"});
 
 
     }
   }
 )
  

 }
 @Output() myOutput:EventEmitter<string>= new EventEmitter();  
         outputMessage:string="close";
 // Function to save a cart
 generateUUIDv4(): string {
  let date:any=new Date().getDate();
  let time:any=new Date().getTime();
  let uuidDate:any=date+time;
  // console.log(date+"t"+time)
  return uuidDate+'-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
 saveCart() {
  // console.log(this.flightData)
 let cabin:any=[{requestedClass:this.flightData[0]?.pnrItineraryDetails[0]?.passengerDetails[0]?.cabinClass}]
  let request={
      // "orderId": "ORD123456",
      // "pnr": "PNR987654",
      // "paymentMedium": "CREDIT_CARD",
      "requestUuid": this.searchRequest?.requestId,
      "channel": "WEB",
      // "airSearchRequest": this.searchRequest,

      "airSearchRequest": {
        "domestic": this.domIn.domestic,
        "paxCount": this.searchRequest?.paxCount,
        "requestId": this.searchRequest?.requestId,
        "adultCount": this.searchRequest?.adultCount,
        "childCount": this.searchRequest?.childCount,
        "travelType": this.searchRequest?.travelType,
        "infantCount": this.searchRequest?.infantCount,
        "journeyType": this.searchRequest?.journeyType,
        "prefAirline": this.searchRequest?.prefAirline,
        "directFlight": this.searchRequest?.directFlight||false,
        "international": this.domIn?.international,
        "airSearchRequestBaseDetails":this.searchRequest?.airSearchRequestBaseDetails||cabin ,
        // "userBookingContext":this.bookingType
      },

      "flightBooking":this.convertData(this.flightData),
      "travellerDetails": {
        "adult": this.searchRequest?.adultCount ||    this.retriveData[0]?.passengerDetails?.filter((passenger:any) => passenger.passengerType === 'ADT').length ||0,
        "child": this.searchRequest?.childCount||    this.retriveData[0]?.passengerDetails?.filter((passenger:any) => ['CHD', 'CNN'].includes(passenger.passengerType)).length||0,
        "infantCount": this.searchRequest?.infantCount ||    this.retriveData[0]?.passengerDetails?.filter((passenger:any) =>['INF', 'INFT'].includes(passenger.passengerType)).length||0
      },
      "bookedFor": "Business",
      "userUid": this.userName.userUid
    }
    

  
  


   this.CartService
   .saveCart(request)
   .subscribe({
     next : (res:any) => {
       if(res) {
        let item:any
        item=res  
         sessionStorage.setItem('CorpUuid',this.userName.userUid)

       let url= "/app/manual-booking?id="+this.SettingsService.transform(item?.orderNumber)
       window.open(url);

         this.toastMsgService.setMsg({msg : '"Cart Added Successfully',msgTitle : "Success", msgType : "I"});

        

         this.myOutput.emit(this.outputMessage);
       } else {
       
       } 
     },error : (err) => {
       this.toastMsgService.setMsg({msg : 'Failed to Save Cart',msgTitle : "Warning", msgType : "W"});
 
 
     }
   }
 )
  
 }

 backClick(){
  this.myOutput.emit(this.outputMessage);

 }
 dateCartFormate(date:any){

  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSS"+'+0530');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}

 sourceCodeList:any=[]
 sourceCodelist(){
 
   this.AirManagementService
   .sourceCodelist()
   .subscribe({
     next : (res:any) => {
       if(res) {
      let data=res
      this.sourceCodeList=data
      
       } else {
       
       } 
     },error : (err) => {
 
     }
   }
 )
 }
 supplierList:any=[]
 Supplierlist(){

  this.AirManagementService
  .supplierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.supplierList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

carrierList:any=[]
    Carrierlist(){

      this.AirManagementService
      .carrierlist()
      .subscribe({
        next : (res:any) => {
          if(res) {
         let data=res
         this.carrierList=data
         

          } else {
          
          } 
        },error : (err) => {
  
        }
      }
    )
    }


    dateFormate(date:any){

      const parsedDate = new Date(date);
      const datePipe = new DatePipe('en-IN');
      date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
      // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    return date
    
    }
    datetimeFormate(date:any){

      const parsedDate = new Date(date);
      const datePipe = new DatePipe('en-IN');
      date = datePipe.transform(parsedDate, 'yyyy-MM-ddT00:00');
      // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
    return date
    
    }
    flightList:any=[]
    getFlightList(){
   
      this.FlightService
      .getFlightList()
      .subscribe({
        next : (res:any) => {
          if(res) {
           let data:any
           data=res  
           this.flightList=data
       
          } else {    
          } 
        },error : (err) => {
    
          
        }
      }
    )
    }
    cityFilter(item:any){
  

      if(item && this.flightList){
       
    
        item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
    
      item=item[0]?.city
    
    return item}else{
      return item
    }
    }
    airportFilter(item:any){
  

      if(item && this.flightList){
       
    
        item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)
    
      item=item[0]?.name
    
    return item}else{
      return item
    }
    }
    travellerArray(item:any){
      // console.log(item)
    
      let traveller=[]
      if(item){
       
    
      for(let i=0;i<item;i++){
        traveller.push(i+1)
    
      }
      
     
    }
    
       
      return traveller
    }


    suggestions: any[] = [];
    filteredUser: any[] = [];;

    searchList(event: AutoCompleteCompleteEvent) {
      let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < (this.suggestions as any[]).length; i++) {
            let user = (this.suggestions as any[])[i];
            if (user.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(user);
            }
        }

        this.filteredUser = filtered;
        console.log(filtered)
    }

    getUsersList(){
      let userType:any
          this.userService.getUserList('')
          .subscribe({
            next : (res:any) => {
              if(res) {
               // console.log(res)
              let  data:any;
              data=res["result"]
              this.suggestions=data
              // for (let i = 0; i < data.length; i++) {
                
              //   this.whereTo.push(data[i]?.name);
    
              // }
       
            }else{
    
            }},error : (err) => {
        
              console.error("Error in fetching data");
            }
          }
        )
        
      }
      onlyNumberKey(event:any) {
     
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
      }


      convertData(data:any){
        console.log(data)
        return data.map((item:any) => ({
          source: item?.pnrItineraryDetails[0]?.source,
          toAirport: item?.pnrItineraryDetails[item?.pnrItineraryDetails?.length-1]?.toAirport,
          fromAirport: item?.pnrItineraryDetails[0]?.fromAirport,
          routeRequest: {
            url: null,
            source: item?.pnrItineraryDetails[0]?.source,
            carriers:  null,
            supplier:item?.pnrItineraryDetails[0]?.supplier,
            tourCode: null,
            privateFareCode: item?.pnrItineraryDetails[0]?.privateFareCode,
          },

          passengerDetails: item?.pnrItineraryDetails[0]?.passengerDetails.map((passenger:any) => ({
            passengerKey:passenger?.passengerKey,
            csrPNR: passenger?.csrPnr,
            pnr: passenger?.pnr,
            universalPnr:passenger?.universalPnr,
            providerPnr:passenger?.providerPnr,
            ticketNumber: passenger?.ticketNumber,
            firstName:passenger?.firstName,
            lastName:passenger?.lastName,
            title:passenger?.passengerTitle,
            mobile:passenger?.mobile,
            email:passenger?.email,
            passengerType:passenger?.passengerType,
            seatMeal:{
            seatMeal: [
              {
                to: item.pnrItineraryDetails[0]?.toAirport,
                from: item.pnrItineraryDetails[0]?.fromAirport,
                seatNumber: item.pnrItineraryDetails[0]?.seatNumber || null,
                mealUnitKey: null,
                seatUnitKey: null,
                mealBasePrice: passenger?.mealBasePrice,
                seatBasePrice: passenger?.seatBasePrice,
                mealPreferences: item.pnrItineraryDetails[0]?.mealPreference || null,
              }
            ]}
          })),
          schArrivalTime: new Date(item?.pnrItineraryDetails[item?.pnrItineraryDetails.length-1]?.schArrivalTime).getTime(),
          schDepartureTime: new Date(item?.pnrItineraryDetails[0]?.schDepartureTime).getTime(),
          travelDuration:this.calculateDurations(new Date(item?.pnrItineraryDetails[item.pnrItineraryDetails?.length-1].schArrivalTime).getTime(),new Date(item?.pnrItineraryDetails[0]?.schDepartureTime).getTime()),

//           fare:[{
//             baseFare: 8000,
// fareBasis: null,
// fareType: "Published",
// fareTypeDisplay: "Published",
// finalTax: 1486,
// surCharge: null,
// tax: null,
// taxes: null,
//           }],


          flightDetailsList: item?.pnrItineraryDetails?.map((pnrItineraryDetail:any) => ({
            
            
            fromTerminal:pnrItineraryDetail?.fromTerminal,
          toTerminal:pnrItineraryDetail?.toTerminal,
            toAirport: pnrItineraryDetail.toAirport,
            carrierName:  pnrItineraryDetail?.carrier,
            fromAirport: pnrItineraryDetail?.fromAirport,
            flightNumber: pnrItineraryDetail?.flightNumber,
            bookingClasses:['ADT','CHD','CNN', 'INF','INFT']
            .map((type) => {
              const passenger = pnrItineraryDetail?.passengerDetails?.find(
                (passenger: any) => passenger?.passengerType === type
              );
              
              if (!passenger) return null;
          
              return {
                fareType: passenger?.fareType,
                fareBasis: passenger?.fareBasis,
                baggageInfo:passenger?.baggageInfo,
                bookingClass: passenger?.bookingClass,
                corporateFare: false,
                passengerType: passenger?.passengerType,
                fareDetailsPerPassengerType: {
                  taxes: {
                    ...passenger.coc.reduce((acc: any, curr: any) => {
                      if (curr.key) {
                        acc[curr.key] = [curr.value];
                      }
                      return acc;
                    }, {} as { [key: string]: number[] }),
                    IN: [passenger.IN],
                    WO: [passenger.WO],
                    YR: [passenger.YR],
                    YQ: [passenger.YQ],
                    JN: [passenger.JN],
                    OB: [passenger.OB],
                    OC: [passenger.OC],
                    SBC: [passenger.SBC],
                    KKC: [passenger.KKC],
                    CGST: [passenger.CGST],
                    SGST: [passenger.SGST],
                    UGST: [passenger.UGST],
                    IGST: [passenger.IGST],
                  },
                  baseFare: passenger.baseFare,
                  finalTax:
                    Number(passenger.YQ) +
                    Number(passenger.YR) +
                    Number(passenger.IN) +
                    Number(passenger.WO) +
                    Number(passenger.JN) +
                    Number(passenger.OB) +
                    Number(passenger.OC) +
                    Number(passenger.SBC) +
                    Number(passenger.KKC) +
                    Number(passenger.CGST) +
                    Number(passenger.SGST) +
                    Number(passenger.UGST) +
                    Number(passenger.IGST) +
                    passenger.coc.reduce((acc: any, curr: any) => acc + Number(curr?.value), 0),
                  passengerType: passenger?.passengerType,
                },
              };
            })
            .filter(Boolean),
            
            // [{...pnrItineraryDetail.passengerDetails.map((passenger:any) => ({
              


//               fareType: passenger.fareType,
//               fareBasis: passenger.fareBasis,
//               bookingClass: passenger.bookingClass,
//               corporateFare: false,
//               passengerType: passenger.passengerType,
//               fareDetailsPerPassengerType: {
               
               
//                 taxes: {
//                   ...passenger.coc.reduce((acc:any, curr:any) => {
//                     if (curr.key) {
//                       acc[curr.key] = [curr.value];
//                     }
//                     return acc; 
//                   }, {} as { [key: string]: number[] }),
//                   IN: [passenger.IN],
//                   WO: [passenger.WO],
//                   YR: [passenger.YR],
//                   YQ: [passenger.YQ],
//                   JN: [passenger.JN],
//                   OB: [passenger.OB],
//                   OC: [passenger.OC],
//                   SBC: [passenger.SBC],
//                   KKC: [passenger.KKC],
//                   CGST: [passenger.CGST],
//                   SGST: [passenger.SGST],
//                   UGST: [passenger.UGST],
//                   IGST: [passenger.IGST],
//                 },
//                 baseFare: passenger.baseFare,
//                 finalTax:Number(passenger.YQ) + Number(passenger.YR) + Number(passenger.IN) + Number(passenger.WO) + Number(passenger.JN) + Number(passenger.OB) + Number(passenger.OC) + Number(passenger.SBC) + Number(passenger.KKC) + Number(passenger.CGST) + Number(passenger.SGST) + Number(passenger.UGST) + Number(passenger.IGST)+passenger.coc.reduce((acc:any, curr:any) => acc + Number(curr.value), 0)
//                 // +Number(passenger.coc.reduce(
//                 //   (acc:any, curr:any) => {
//                 //     if (curr.key) {
//                 //       acc.cocTotal += curr.value;
//                 //     }
//                 //     return acc;
//                 //   },
//                 //   {  cocTotal: 0 }
//                 // )),
// ,
//                 passengerType: passenger.passengerType
//               }
//             })).filter((passengerT:any)=>passengerT.passengerType==='ADT')[0],...pnrItineraryDetail.passengerDetails.map((passenger:any) => ({
              


//               fareType: passenger.fareType,
//               fareBasis: passenger.fareBasis,
//               bookingClass: passenger.bookingClass,
//               corporateFare: false,
//               passengerType: passenger.passengerType,
//               fareDetailsPerPassengerType: {
               
               
//                 taxes: {
//                   ...passenger.coc.reduce((acc:any, curr:any) => {
//                     if (curr.key) {
//                       acc[curr.key] = [curr.value];
//                     }
//                     return acc;
//                   }, {} as { [key: string]: number[] }),
//                   IN: [passenger.IN],
//                   WO: [passenger.WO],
//                   YR: [passenger.YR],
//                   YQ: [passenger.YQ],
//                   JN: [passenger.JN],
//                   OB: [passenger.OB],
//                   OC: [passenger.OC],
//                   SBC: [passenger.SBC],
//                   KKC: [passenger.KKC],
//                   CGST: [passenger.CGST],
//                   SGST: [passenger.SGST],
//                   UGST: [passenger.UGST],
//                   IGST: [passenger.IGST],
//                 },
//                 baseFare: passenger.baseFare,
//                 finalTax:Number(passenger.YQ) + Number(passenger.YR) + Number(passenger.IN) + Number(passenger.WO) + Number(passenger.JN) + Number(passenger.OB) + Number(passenger.OC) + Number(passenger.SBC) + Number(passenger.KKC) + Number(passenger.CGST) + Number(passenger.SGST) + Number(passenger.UGST) + Number(passenger.IGST)+passenger.coc.reduce((acc:any, curr:any) => acc + Number(curr.value), 0)
//                 // +Number(passenger.coc.reduce(
//                 //   (acc:any, curr:any) => {
//                 //     if (curr.key) {
//                 //       acc.cocTotal += curr.value;
//                 //     }
//                 //     return acc;
//                 //   },
//                 //   {  cocTotal: 0 }
//                 // )),
// ,
//                 passengerType: passenger.passengerType
//               }
//             })).filter((passengerT:any)=>passengerT.passengerType==='CHD')[0],...pnrItineraryDetail.passengerDetails.map((passenger:any) => ({
              


//               fareType: passenger.fareType,
//               fareBasis: passenger.fareBasis,
//               bookingClass: passenger.bookingClass,
//               corporateFare: false,
//               passengerType: passenger.passengerType,
//               fareDetailsPerPassengerType: {
               
               
//                 taxes: {
//                   ...passenger.coc.reduce((acc:any, curr:any) => {
//                     if (curr.key) {
//                       acc[curr.key] = [curr.value];
//                     }
//                     return acc;
//                   }, {} as { [key: string]: number[] }),
//                   IN: [passenger.IN],
//                   WO: [passenger.WO],
//                   YR: [passenger.YR],
//                   YQ: [passenger.YQ],
//                   JN: [passenger.JN],
//                   OB: [passenger.OB],
//                   OC: [passenger.OC],
//                   SBC: [passenger.SBC],
//                   KKC: [passenger.KKC],
//                   CGST: [passenger.CGST],
//                   SGST: [passenger.SGST],
//                   UGST: [passenger.UGST],
//                   IGST: [passenger.IGST],
//                 },
//                 baseFare: passenger.baseFare,
//                 finalTax:Number(passenger.YQ) + Number(passenger.YR) + Number(passenger.IN) + Number(passenger.WO) + Number(passenger.JN) + Number(passenger.OB) + Number(passenger.OC) + Number(passenger.SBC) + Number(passenger.KKC) + Number(passenger.CGST) + Number(passenger.SGST) + Number(passenger.UGST) + Number(passenger.IGST)+passenger.coc.reduce((acc:any, curr:any) => acc + Number(curr.value), 0)
               
// ,
//                 passengerType: passenger.passengerType
//               }
//             })).filter((passengerT:any)=>passengerT.passengerType==='INF')[0]}],
            schArrivalTime: this.dateCartFormate(pnrItineraryDetail?.schArrivalTime),
            schDepartureTime: this.dateCartFormate(pnrItineraryDetail?.schDepartureTime),
            travelDuration:this.calculateDurations(this.dateCartFormate(pnrItineraryDetail?.schArrivalTime),this.dateCartFormate(pnrItineraryDetail?.schDepartureTime)),

            
            
            
          }))
            /*[
            {
              toAirport: item.toAirport,
              carrierName:  item?.carrier,
              fromAirport: item.fromAirport,
              flightNumber: item.flightNumber,
              bookingClasses:[{...item.passengerDetails.map((passenger:any) => ({
                


                fareType: passenger.fareType,
                fareBasis: passenger.fareBasis,
                bookingClass: passenger.bookingClass,
                corporateFare: false,
                passengerType: passenger.passengerType,
                fareDetailsPerPassengerType: {
                 
                 
                  taxes: {
                    ...passenger.coc.reduce((acc:any, curr:any) => {
                      if (curr.key) {
                        acc[curr.key] = [curr.value];
                      }
                      return acc; 
                    }, {} as { [key: string]: number[] }),
                    IN: [passenger.IN],
                    WO: [passenger.WO],
                    YR: [passenger.YR],
                    YQ: [passenger.YQ],
                    JN: [passenger.JN],
                    OB: [passenger.OB],
                    OC: [passenger.OC],
                    SBC: [passenger.SBC],
                    KKC: [passenger.KKC],
                    CGST: [passenger.CGST],
                    SGST: [passenger.SGST],
                    UGST: [passenger.UGST],
                    IGST: [passenger.IGST],
                  },
                  baseFare: passenger.baseFare,
                  finalTax:Number(passenger.YQ) + Number(passenger.YR) + Number(passenger.IN) + Number(passenger.WO) + Number(passenger.JN) + Number(passenger.OB) + Number(passenger.OC) + Number(passenger.SBC) + Number(passenger.KKC) + Number(passenger.CGST) + Number(passenger.SGST) + Number(passenger.UGST) + Number(passenger.IGST)+passenger.coc.reduce((acc:any, curr:any) => acc + Number(curr.value), 0)
                  // +Number(passenger.coc.reduce(
                  //   (acc:any, curr:any) => {
                  //     if (curr.key) {
                  //       acc.cocTotal += curr.value;
                  //     }
                  //     return acc;
                  //   },
                  //   {  cocTotal: 0 }
                  // )),
,
                  passengerType: passenger.passengerType
                }
              })).filter((passengerT:any)=>passengerT.passengerType==='ADT')[0],...item.passengerDetails.map((passenger:any) => ({
                


                fareType: passenger.fareType,
                fareBasis: passenger.fareBasis,
                bookingClass: passenger.bookingClass,
                corporateFare: false,
                passengerType: passenger.passengerType,
                fareDetailsPerPassengerType: {
                 
                 
                  taxes: {
                    ...passenger.coc.reduce((acc:any, curr:any) => {
                      if (curr.key) {
                        acc[curr.key] = [curr.value];
                      }
                      return acc;
                    }, {} as { [key: string]: number[] }),
                    IN: [passenger.IN],
                    WO: [passenger.WO],
                    YR: [passenger.YR],
                    YQ: [passenger.YQ],
                    JN: [passenger.JN],
                    OB: [passenger.OB],
                    OC: [passenger.OC],
                    SBC: [passenger.SBC],
                    KKC: [passenger.KKC],
                    CGST: [passenger.CGST],
                    SGST: [passenger.SGST],
                    UGST: [passenger.UGST],
                    IGST: [passenger.IGST],
                  },
                  baseFare: passenger.baseFare,
                  finalTax:Number(passenger.YQ) + Number(passenger.YR) + Number(passenger.IN) + Number(passenger.WO) + Number(passenger.JN) + Number(passenger.OB) + Number(passenger.OC) + Number(passenger.SBC) + Number(passenger.KKC) + Number(passenger.CGST) + Number(passenger.SGST) + Number(passenger.UGST) + Number(passenger.IGST)+passenger.coc.reduce((acc:any, curr:any) => acc + Number(curr.value), 0)
                  // +Number(passenger.coc.reduce(
                  //   (acc:any, curr:any) => {
                  //     if (curr.key) {
                  //       acc.cocTotal += curr.value;
                  //     }
                  //     return acc;
                  //   },
                  //   {  cocTotal: 0 }
                  // )),
,
                  passengerType: passenger.passengerType
                }
              })).filter((passengerT:any)=>passengerT.passengerType==='CHD')[0],...item.passengerDetails.map((passenger:any) => ({
                


                fareType: passenger.fareType,
                fareBasis: passenger.fareBasis,
                bookingClass: passenger.bookingClass,
                corporateFare: false,
                passengerType: passenger.passengerType,
                fareDetailsPerPassengerType: {
                 
                 
                  taxes: {
                    ...passenger.coc.reduce((acc:any, curr:any) => {
                      if (curr.key) {
                        acc[curr.key] = [curr.value];
                      }
                      return acc;
                    }, {} as { [key: string]: number[] }),
                    IN: [passenger.IN],
                    WO: [passenger.WO],
                    YR: [passenger.YR],
                    YQ: [passenger.YQ],
                    JN: [passenger.JN],
                    OB: [passenger.OB],
                    OC: [passenger.OC],
                    SBC: [passenger.SBC],
                    KKC: [passenger.KKC],
                    CGST: [passenger.CGST],
                    SGST: [passenger.SGST],
                    UGST: [passenger.UGST],
                    IGST: [passenger.IGST],
                  },
                  baseFare: passenger.baseFare,
                  finalTax:Number(passenger.YQ) + Number(passenger.YR) + Number(passenger.IN) + Number(passenger.WO) + Number(passenger.JN) + Number(passenger.OB) + Number(passenger.OC) + Number(passenger.SBC) + Number(passenger.KKC) + Number(passenger.CGST) + Number(passenger.SGST) + Number(passenger.UGST) + Number(passenger.IGST)+passenger.coc.reduce((acc:any, curr:any) => acc + Number(curr.value), 0)
                  // +Number(passenger.coc.reduce(
                  //   (acc:any, curr:any) => {
                  //     if (curr.key) {
                  //       acc.cocTotal += curr.value;
                  //     }
                  //     return acc;
                  //   },
                  //   {  cocTotal: 0 }
                  // )),
,
                  passengerType: passenger.passengerType
                }
              })).filter((passengerT:any)=>passengerT.passengerType==='INF')[0]}],
              schArrivalTime: this.dateCartFormate(item.schArrivalTime),
              schDepartureTime: this.dateCartFormate(item.schDepartureTime),
              travelDuration:this.calculateDurations(this.dateCartFormate(item.schArrivalTime),this.dateCartFormate(item.schDepartureTime)),

            }
          ]*/
        }));
      }

      calculateDurations(schArrivalTime: any, schDepartureTime: any): any {
        
        // Parse the ISO strings into Date objects
        const arrivalTime = new Date(schArrivalTime);
        const departureTime = new Date(schDepartureTime);
      
        // Calculate the difference in milliseconds
        const durationMillis = arrivalTime.getTime() - departureTime.getTime();
      
        const durationMinutes = durationMillis / (1000 * 60);
      
      
        // Format the result
        return durationMinutes;
      }
      totalTax(taxes:any){
        let totalTax:any=0
        for (let key in taxes) {
          totalTax += taxes[key][0];
      }
      return totalTax
      }

      disabled(f:any){
if(f.valid){
  return false
}
return true
      }

    


      total(passenger:any){

        passenger.baseTotal= Number(passenger.baseFare)+Number(passenger.YQ) + Number(passenger.YR) + Number(passenger.IN) + Number(passenger.WO) + Number(passenger.JN),
        passenger.taxTotal=Number(passenger.OB) + Number(passenger.OC) + Number(passenger.SBC) + Number(passenger.KKC) + Number(passenger.CGST) + Number(passenger.SGST) + Number(passenger.UGST) + Number(passenger.IGST)
       
        passenger.extraTotal=Number(passenger.mealBasePrice)
        passenger.cocTotal=passenger.coc.reduce((acc:any, curr:any) => acc + Number(curr.value), 0)

        passenger.totalPrice= passenger.baseTotal+passenger.taxTotal+passenger.extraTotal+passenger.cocTotal
        // +Number(passenger.coc.reduce(
      }

fullScreen:boolean=false
      @ViewChild('containers', { static: false }) container!: ElementRef;
      toggleFullscreen() {
        if (!document.fullscreenElement) {
          this.enterFullscreen();
          this.fullScreen=true

        } else {
          this.exitFullscreen();
          this.fullScreen=false

        }
      }
    
  goFullscreen() {
    if (this.container.nativeElement.requestFullscreen) {
      this.container.nativeElement.requestFullscreen();
    } else if (this.container.nativeElement.mozRequestFullScreen) { // Firefox
      this.container.nativeElement.mozRequestFullScreen();
    } else if (this.container.nativeElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
      this.container.nativeElement.webkitRequestFullscreen();
    } else if (this.container.nativeElement.msRequestFullscreen) { // IE/Edge
      this.container.nativeElement.msRequestFullscreen();
    }
  }
  ngOnDestroy() {
    // Ensure fullscreen is exited when component is destroyed
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  }

  enterFullscreen() {
    if (this.container.nativeElement.requestFullscreen) {
      this.container.nativeElement.requestFullscreen();
    } else if (this.container.nativeElement.mozRequestFullScreen) { // Firefox
      this.container.nativeElement.mozRequestFullScreen();
    } else if (this.container.nativeElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
      this.container.nativeElement.webkitRequestFullscreen();
    } else if (this.container.nativeElement.msRequestFullscreen) { // IE/Edge
      this.container.nativeElement.msRequestFullscreen();
    }
  }

  exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
  

  
}
